import React, { Component, createRef } from "react";
import axios from 'axios';
import { Button, Grid, IconButton, SelectChangeEvent, Snackbar, Typography, Alert, Box, Dialog, DialogContent, DialogTitle, DialogContentText } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { baseUrl } from './ApiCommonService';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { fetchAllLobs } from '../ApiSevices/FileUploadApis';
import { expTokenProcessAndGenerate } from "../ApiSevices/AuthApis";
import { FileUpload } from '@mui/icons-material';
import { fetchBrokerFileUploadLImit } from "../ApiSevices/ExdionAdminApi";
const token = sessionStorage.getItem('token');
interface UploadedFile {
    name: any;
    file: File;
    docType: string;
}

interface TableProps {
    modelJobTypeId: any;
    ReuploadRowId: any;
    fileReUploadInfo: any;
    UfjobId: any;
    searchJob_ID: any;
    onSuccessfulUpload?: (jobId: string) => void;
}

interface State {
    jobId: any;
    JobId: any;
    openJobid: any;
    successfullyUploadedFields: any;
    successfullyUploadedDocs: any;
    lockedFieldsMessage: any;
    activeTab: "AutomaticRenewal" | "MarketedRenewal";
    uploadedFiles: {
        AutomaticRenewal: { [key: string]: UploadedFile[] };
        MarketedRenewal: { [key: string]: UploadedFile[] };
    };
    selectedCoverage: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    lobCodes: { Lob_Name: string; Lob_Code: string }[];
    selectedChecklist: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    remarks: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    clientName: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    errors: {
        [key: string]: {
            lineOfCoverage: string;
            checklist: string;
            currentTermPolicy: string;
            priorTermPolicy: string;
            duplicateFiles: string;
            sourceDoc: string;
        }
    };
    corruptedFiles: any;
    emptyFiles: any;
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: any;
    loading: boolean;
    activeUploadFieldName: any;
    openConfirmDialog: any;
    dialogFieldName: any;
    dialogFileId: any;
}

class FileReUploadpage extends Component<TableProps, State> {
    private fileInputRefs: Record<string, React.RefObject<HTMLInputElement>>;
    docTypeArray: Record<string, number> = { "Current Term Policy": 1, "Prior Term Policy": 2, "Current Endorsement": 3, "Prior Endorsement": 4, "Acord Application": 5, "Carrier Quote": 6, "Proposal": 7, "Schedule": 8, "Binder": 9 }

    constructor(props: TableProps) {
        super(props);
        this.state = {
            jobId: null,
            JobId: null,
            openJobid: null,
            successfullyUploadedFields: {},
            successfullyUploadedDocs: {},
            lockedFieldsMessage: '',
            activeTab: "AutomaticRenewal",
            openConfirmDialog: false,
            dialogFieldName: '',
            dialogFileId: null,
            uploadedFiles: {
                AutomaticRenewal: {},
                MarketedRenewal: {},
            },
            selectedCoverage: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            lobCodes: [],
            selectedChecklist: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            remarks: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            clientName: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            errors: {
                AutomaticRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                },
                MarketedRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                }
            },
            corruptedFiles: {},
            emptyFiles: {},
            snackbarOpen: false,
            snackbarMessage: "",
            snackbarSeverity: "error",
            loading: false,
            activeUploadFieldName: null

        };
        this.fileInputRefs = {};

    }

    componentDidMount() {
        this.fetchLobs();
    }

    fetchLobs = async () => {
        try {
            const fetchResponse = await fetchAllLobs();
            if (fetchResponse && fetchResponse?.length > 0) {
                this.setState({ lobCodes: Array.from(new Set(fetchResponse)) });
            }
        } catch (error) {
            console.error('Error fetching lobData:', error);
        }
    };

    handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        this.setState({ activeTab: newValue as "AutomaticRenewal" | "MarketedRenewal" });
    };

    validateFileUpload = (fieldName: string, file: File, activeTab: string, existingFiles: UploadedFile[]) => {
        const { modelJobTypeId } = this.props;
        const pdfOnlyFields = ["Current Term Policy", "Prior Term Policy", "Current Endorsement", "Prior Endorsement"]
        const PEW_FilesOnly = ["Proposal"]                  // Pdf, Excel & Word Only
        const PW_FilesOnly = ["Carrier Quote", "Binder"]    // Pdf, Word Only
        const PE_FilesOnly = ["Acord Application", "Schedule"]  // Pdf, Excel Only

        let allowedFormats: string[] | undefined;
        const extentionNameMap: Record<string, string> = {
            pdf: "PDF",
            doc: "Word",
            docx: "Word",
            xlsx: 'Excel',
            xls: 'Excel'
        }

        if (PEW_FilesOnly?.includes(fieldName)) {
            allowedFormats = ["pdf", "doc", "docx", "xlsx", "xls"];
        } else if (pdfOnlyFields?.includes(fieldName)) {
            allowedFormats = ["pdf"];
        } else if (PW_FilesOnly?.includes(fieldName)) {
            allowedFormats = ["pdf", "doc", "docx"];
        } else if (PE_FilesOnly?.includes(fieldName)) {
            allowedFormats = ["pdf", "xlsx", "xls"];
        }

        const fileExtension = file?.name?.split(".").pop()?.toLowerCase();
        if (!fileExtension || !allowedFormats?.includes(fileExtension)) {
            const namesSet = new Set<string>();

            for (const exe of allowedFormats ?? []) {
                const name = extentionNameMap[exe];
                if (name) namesSet.add(name)
            }

            const typeNames = Array.from(namesSet);
            const last = typeNames.pop();
            const readable = typeNames.length
                ? `${typeNames.join(", ")} and ${last}`
                : last;

            return `Only ${readable} files are allowed`;
        }
        
        // Enforce single file restriction for specific fields
        const singleFileFields = ["Current Term Policy", "Prior Term Policy"];
        if (singleFileFields?.includes(fieldName) && existingFiles?.length > 0) {
            return `${fieldName} allows only a single file`;
        }

        if (modelJobTypeId === 2) {
            const multipleFormatFields = ["Proposal", "Acord Application", "Carrier Quote", "Binder"];
            if (multipleFormatFields?.includes(fieldName) && existingFiles.length > 0) {
                return `${fieldName} allows only a single file`;
            }
        }
        return null;
    };

    handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        const { files } = e.target;
        const { activeTab, uploadedFiles } = this.state;
        const maxSize = 80 * 1024 * 1024; // 80MB
        if (!files) return;

        if (files && files.length > 0) {
            let newFiles: UploadedFile[] = [];

            // Get existing files for multi-file support
            const existingFiles: UploadedFile[] = (uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (file && file?.size > maxSize) {
                    alert("File size must be less than 80MB.");
                    e.target.value = "";
                    return false
                }
                const sameFieldFileNameCheck = existingFiles?.some(item => item?.name === file?.name);
                if (sameFieldFileNameCheck) {
                    alert(`This file has already been selected:\n ${file?.name}`);
                    e.target.value = '';
                    return false;
                }

                const errorMessage = this.validateFileUpload(fieldName, file, activeTab, existingFiles);

                if (errorMessage) {
                    this.setState(
                        { snackbarOpen: true, snackbarMessage: errorMessage },
                        () => console.error("Snackbar triggered with message:", errorMessage)
                    );
                    e.target.value = "";
                    return;
                }

                const docType = String(this.docTypeArray[fieldName] || "");
                newFiles.push({ name: file.name, file, docType });
            }

            if (newFiles.length > 0) {
                this.setState((prevState) => {
                    const prevFiles: UploadedFile[] = (prevState.uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];

                    return {
                        uploadedFiles: {
                            ...prevState.uploadedFiles,
                            [activeTab]: {
                                ...prevState.uploadedFiles[activeTab],
                                [fieldName]: fieldName === "Current Term Policy" || fieldName === "Prior Term Policy"
                                    ? newFiles  // Replace for single-file fields
                                    : [...prevFiles, ...newFiles],  // Append for multi-file fields
                            },
                        },

                        errors: {
                            ...prevState.errors,
                            [activeTab]: {
                                ...prevState.errors[activeTab],
                                currentTermPolicy: fieldName === "Current Term Policy" ? "" : prevState.errors[activeTab]?.currentTermPolicy,
                                priorTermPolicy: fieldName === "Prior Term Policy" ? "" : prevState.errors[activeTab]?.priorTermPolicy,
                                lineOfCoverage: fieldName !== "Current Term Policy" && fieldName !== "Prior Term Policy"
                                    ? "" : prevState.errors[activeTab]?.lineOfCoverage,
                            }
                        }
                    };
                });
            }
        }

        // Reset input to allow re-upload of the same file
        const inputFile = this.fileInputRefs[fieldName]?.current;
        if (inputFile) {
            inputFile.value = "";
        }
    };

    handleDrop = (e: React.DragEvent<HTMLDivElement>, fieldName: string) => {
        e.preventDefault();

        // If another field is already active and it's not this one, disable
        if (this.state.activeUploadFieldName && this.state.activeUploadFieldName !== fieldName) return;

        const isMultiFile = ["Current Endorsement", "Prior Endorsement"].includes(fieldName);
        const droppedFiles = Array.from(e.dataTransfer.files);

        if (!isMultiFile && droppedFiles.length > 1) {
            alert(`Only one file is allowed for the ${fieldName}.`);
            return;
        }

        const fileList = isMultiFile ? droppedFiles : [droppedFiles[0]];

        // Simulate input change event
        const event = {
            target: { files: fileList }
        } as unknown as React.ChangeEvent<HTMLInputElement>;

        // Set active field here
        this.setState({ activeUploadFieldName: fieldName }, () => {
            this.handleFileUpload(event, fieldName);
        });
    };

    handleRemarksChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { activeTab, remarks } = this.state;
        this.setState({
            remarks: {
                ...remarks,
                [activeTab]: event.target.value,
            },
        });
    };

    handleClientNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event?.target;
        if (/^[A-Za-z\s]*$/.test(value)) {
            const { activeTab, clientName } = this.state;
            this.setState({
                clientName: {
                    ...clientName,
                    [activeTab]: value,
                },
            });
        }
    };

    handleCoverageChange = async (event: SelectChangeEvent<string>) => {
        const selectedCoverage = event?.target?.value;
        const { activeTab } = this.state;
        this.setState((prevState) => ({
            selectedCoverage: {
                ...prevState.selectedCoverage,
                [activeTab]: selectedCoverage,
            },
            errors: {
                ...prevState.errors,
                [activeTab]: {
                    ...prevState.errors[activeTab],
                    lineOfCoverage: "",  // Clear only the lineOfCoverage error
                }
            },
        }))
    };

    handleChecklistChange = (event: SelectChangeEvent<string>) => {
        const { activeTab, selectedChecklist, errors } = this.state;
        this.setState({
            selectedChecklist: {
                ...selectedChecklist,
                [activeTab]: event.target.value,
            },
            errors: {
                ...errors,
                [activeTab]: {
                    ...errors[activeTab],
                    checklist: "", // Clear the error message once the field is changed
                }
            },
        });
    };

    handleFileRemove = (fieldName: string, fileIndex?: number) => {
        const { activeTab, uploadedFiles } = this.state;
        const existingFiles = uploadedFiles[activeTab]?.[fieldName];

        if (Array.isArray(existingFiles)) {
            if (fileIndex !== undefined && fileIndex >= 0 && fileIndex < existingFiles.length) {
                // Remove specific file
                const updatedFiles = [...existingFiles];
                updatedFiles.splice(fileIndex, 1);

                this.setState({
                    uploadedFiles: {
                        ...uploadedFiles,
                        [activeTab]: {
                            ...uploadedFiles[activeTab],
                            [fieldName]: updatedFiles.length ? updatedFiles : null,
                        },
                    },
                });
            }
        } else {
            // Remove all files
            this.setState({
                uploadedFiles: {
                    ...uploadedFiles,
                    [activeTab]: {
                        ...uploadedFiles[activeTab],
                        [fieldName]: null,
                    },
                },
            });
        }
        if (this.fileInputRefs[fieldName]?.current) {
            this.fileInputRefs[fieldName].current!.value = "";
        }
    };

    validateForm = () => {
        const { modelJobTypeId } = this.props
        const { activeTab, uploadedFiles } = this.state;
        let errors = { ...this.state.errors };
        errors[activeTab] = {
            lineOfCoverage: "",
            checklist: "",
            currentTermPolicy: "",
            priorTermPolicy: "",
            duplicateFiles: "",
            sourceDoc: "",
        };
        const fieldNames = ["Current Term Policy", "Prior Term Policy", "Current Endorsement",
            "Prior Endorsement", "Proposal", "Acord Application", "Carrier Quote", "Binder", "Schedule"];
        const uploadedTab = uploadedFiles[activeTab];
        let alertFlag = false;
        if (uploadedTab) {
            const file = new Set();
            for (const field of fieldNames) {
                uploadedTab[field]?.forEach(fileObj => {
                    const fileExist = fileObj?.file?.name;
                    if (fileExist) {
                        const fileMatch = fileExist;
                        if (file.has(fileMatch)) {
                            alertFlag = true;
                        }
                    }
                    file.add(fileExist);
                })
            }
            if (alertFlag) {
                alert('Duplicate document uploaded. Please check the document and reupload');
                return false;
            }
        }
        return true;
    };

    handleSubmit = async (fieldName?: string) => {
        if (this.validateForm()) {
            const { activeTab, uploadedFiles, successfullyUploadedDocs } = this.state;
            const { UfjobId, searchJob_ID } = this.props;
            const token = sessionStorage.getItem("token");
            this.setState({ loading: true });
            try {
                const Token = await expTokenProcessAndGenerate(token);

                const getBrokerId = Number(searchJob_ID?.slice(0, 4))
                const brokerFileSizeRestriction = await fetchBrokerFileUploadLImit(getBrokerId);
                const DEFAULT_FILE_SIZE_MB = 80;

                const maxFileSizeMB = brokerFileSizeRestriction && brokerFileSizeRestriction?.INT_FILE_SIZE
                    ? brokerFileSizeRestriction?.INT_FILE_SIZE
                    : DEFAULT_FILE_SIZE_MB;
                const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

                const filesToUpload = uploadedFiles[activeTab];
                const uploadPromises = [];
                const newSuccessfullyUploadedDocs = { ...successfullyUploadedDocs };

                const oversizedFiles: string[] = [];
                for (const key in filesToUpload) {
                    const uploadedFile = filesToUpload[key];
                    if (!uploadedFile) continue;

                    for (const { file } of uploadedFile) {
                        if (!file) continue;
                        if (file.size > maxFileSizeBytes) {
                            oversizedFiles.push(file.name);
                        }
                    }
                }

                if (oversizedFiles.length > 0) {
                    alert(
                        `Exceeds the allowed size limit of ${maxFileSizeMB} MB for this BrokerId:\n\n${oversizedFiles.join(
                            ", "
                        )}\n\nPlease remove them and try again.`
                    );
                    this.setState({ loading: false });
                    return;
                }

                if (filesToUpload) {
                    const keysToProcess = fieldName ? [fieldName] : Object.keys(filesToUpload); //  Key line

                    for (const key of keysToProcess) {
                        const uploadedFile = filesToUpload[key];
                        if (!uploadedFile) continue;

                        for (const { file, docType } of uploadedFile) {
                            if (!file) continue;

                            const formData = new FormData();
                            formData.append("files", file);
                            formData.append("jobid", UfjobId);
                            formData.append("documenttype", docType.toString());

                            const uploadPromise = axios
                                .post(
                                    `${baseUrl}api/Upload/UploadPdfs?documenttype=${docType}&jobid=${UfjobId}`,
                                    formData,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${Token}`,
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }
                                )
                                .then((response) => ({
                                    response,
                                    docType,
                                    key,
                                    fileName: file.name,
                                }))
                                .catch((error) => {
                                    console.error("Error uploading file:", error);
                                    return null;
                                });

                            uploadPromises.push(uploadPromise);
                        }
                    }

                    const uploadResults = await Promise.all(uploadPromises);

                    const docTypeAry: any = [];
                    const corruptedFilesMap: any = {};
                    const emptyFilesMap: any = {};
                    const existingFilesMap: any = {}; // New map for checking existing files
                    const successFilesMap: any = {};

                    uploadResults?.forEach((result) => {
                        if (!result) return;

                        const { response, docType, key, fileName } = result;
                        const responseData = response?.data;

                        if (Array.isArray(responseData) && responseData.length > 0) {
                            responseData.forEach((fileCheck) => {
                                const message = fileCheck?.message;
                                const documentType = fileCheck?.documenttype;

                                if (fileCheck?.is_corrupted) {
                                    docTypeAry.push(documentType);
                                    corruptedFilesMap[key] = corruptedFilesMap[key] || [];
                                    corruptedFilesMap[key].push({ docType, fileName, message });
                                }

                                if (fileCheck?.is_file_empty) {
                                    docTypeAry.push(documentType);
                                    emptyFilesMap[key] = emptyFilesMap[key] || [];
                                    emptyFilesMap[key].push({ docType, fileName, message });
                                }

                                if (fileCheck?.is_file_already_exists) {
                                    existingFilesMap[key] = existingFilesMap[key] || [];
                                    existingFilesMap[key].push({ docType, fileName, message });
                                }

                                // Add success message capture
                                if (
                                    !fileCheck?.is_corrupted &&
                                    !fileCheck?.is_file_empty &&
                                    !fileCheck?.is_file_already_exists &&
                                    fileCheck?.message?.toLowerCase().includes("success")
                                ) {
                                    successFilesMap[key] = successFilesMap[key] || [];
                                    successFilesMap[key].push({ docType, fileName, message });
                                }
                            });
                        }
                    });
                    // Initialize message container
                    const messageParts: string[] = [];

                    // Helper function to reset files
                    const resetUploadedFiles = () => {
                        this.setState((prevState) => ({
                            uploadedFiles: {
                                ...prevState.uploadedFiles,
                                [activeTab]: {},
                            },
                        }));
                    };

                    // Handle corrupted files
                    if (Object.keys(corruptedFilesMap).length > 0) {
                        const corruptedMessages = (Object.values(corruptedFilesMap).flat() as { fileName: string; message?: string }[])
                            .map(f => `${f.fileName} ${f.message}`);
                        messageParts.push(...corruptedMessages);
                        resetUploadedFiles();
                    }

                    // Handle empty files
                    if (Object.keys(emptyFilesMap).length > 0) {
                        const emptyMessages = (Object.values(emptyFilesMap).flat() as { fileName: string; message?: string }[])
                            .map(f => `${f.fileName} ${f.message}`);
                        messageParts.push(...emptyMessages);
                        resetUploadedFiles();
                    }

                    // Handle already existing files with custom messages
                    if (Object.keys(existingFilesMap).length > 0) {
                        const existingMessages = (Object.values(existingFilesMap).flat() as { fileName: string, message?: string }[])
                            .map(f => f.message || `The file ${f.fileName} already exists.`);
                        messageParts.push(...existingMessages);
                        resetUploadedFiles();
                    }

                    // Handle successful files
                    if (Object.keys(successFilesMap).length > 0) {
                        const successMessages = (Object.values(successFilesMap).flat() as { fileName: string; message?: string }[])
                            .map(f => `${f.fileName}: ${f.message}`);
                        messageParts.push(...successMessages);

                        if (this.props.onSuccessfulUpload && typeof this.props.onSuccessfulUpload === "function") {
                            await this.props.onSuccessfulUpload(this.props.UfjobId);
                        }
                    }

                    this.setState((prevState) => ({
                        successfullyUploadedFields: {
                            ...prevState.successfullyUploadedFields,
                            [activeTab]: {
                                ...prevState.successfullyUploadedFields[activeTab],
                            },
                        },
                        successfullyUploadedDocs: {
                            ...prevState.successfullyUploadedDocs,
                            [activeTab]: {
                                ...prevState.successfullyUploadedDocs?.[activeTab],
                            },
                        },
                    }));
                    setTimeout(() => {
                        this.setState((prevState) => ({
                            uploadedFiles: {
                                ...prevState.uploadedFiles,
                                [activeTab]: {},
                            },
                            lockedFieldsMessage: ""
                        }));
                    }, 1000);
                    // If there are any issues, set the snackbar message
                    if (messageParts.length > 0) {
                        const joinedMessage = messageParts.join(" ");
                        const isSuccess = joinedMessage.includes("processed successfully");
                        this.setState({
                            snackbarOpen: true,
                            snackbarMessage: joinedMessage,
                            snackbarSeverity: isSuccess ? "success" : "error"
                        });
                        return uploadResults;
                    }
                    return uploadResults;
                }
            } catch (error) {
                console.error("Error in jobId creation API calls:", error);
            } finally {
                this.setState({ loading: false, activeUploadFieldName: null });
            }
        }
    };

    RepoladSubmit = async (Id: any) => {
        try {
            const ID = Id;
            const Token = await expTokenProcessAndGenerate(token);
            this.setState({ loading: true });
            const response = await axios.post(baseUrl + "api/fileInfo/removeFileInfo", [ID], {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Error creating_Or_updating user:", error);
            throw error;
        } finally {
            this.setState({ loading: false, activeUploadFieldName: null });
        }
    };

    showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleOpenConfirmDialog = (fieldName: string, FileId: any) => {
        this.setState({
            openConfirmDialog: true,
            dialogFieldName: fieldName,
            dialogFileId: FileId,
        });
    };

    handleCloseConfirmDialog = () => {
        this.setState({
            openConfirmDialog: false,
            dialogFieldName: '',
            dialogFileId: null,
        });
    };

    handleConfirmUpload = async () => {
        const { dialogFieldName, dialogFileId } = this.state;
        const { fileReUploadInfo } = this.props;

        try {
            const uploadResponse = await this.handleSubmit(dialogFieldName);

            const fileExists = fileReUploadInfo.some(
                (file: { FileForId: any }) => file.FileForId === dialogFileId
            );

            if (fileExists) {
                const { is_corrupted, is_file_already_exists, is_file_empty } =
                    uploadResponse?.[0]?.response?.data?.[0] || {};

                if (!is_corrupted && !is_file_already_exists && !is_file_empty) {
                    const filesToReupload = fileReUploadInfo.filter(
                        (file: { FileForId: any }) => file.FileForId === dialogFileId
                    );
                    for (const file of filesToReupload) {
                        await this.RepoladSubmit(file.Id);
                    }
                }
            }
        } catch (error) {
            console.error("Error in upload/re-upload process:", error);
        } finally {
            this.handleCloseConfirmDialog();
        }
    };

    renderFileUpload = (fieldName: string, label: string, isRequired: boolean = false, FileId: any) => {
        if (!this.fileInputRefs[fieldName]) {
            this.fileInputRefs[fieldName] = createRef();
        }
        const { activeTab, uploadedFiles, successfullyUploadedFields, lockedFieldsMessage } = this.state;
        const { fileReUploadInfo } = this.props;
        const isMultiFile = ["Current Endorsement", "Prior Endorsement"].includes(fieldName);
        const files: UploadedFile[] = (uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];
        const isActiveField = this.state.activeUploadFieldName === fieldName;
        const isDisabled = this.state.activeUploadFieldName && !isActiveField;

        // const isDisabled = this.state.activeUploadFieldName && this.state.activeUploadFieldName !== fieldName;

        const fileExists = fileReUploadInfo.some((file: { FileForId: any }) => file.FileForId === FileId);
        return (
            <fieldset style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                border: "1px solid #ddd",
                padding: "15px",
                borderRadius: "5px",
                marginTop: "10px"
            }}>
                <Grid
                    container
                    spacing={1}
                    alignItems="flex-start"
                    onDragOver={(e) => {
                        if (isDisabled) return;
                        e.preventDefault();
                    }}
                    onDrop={(e) => {
                        if (isDisabled) {
                            e.preventDefault();
                            return;
                        }
                        this.handleDrop(e, fieldName);
                    }}
                    onDragLeave={(e) => {
                        if (isDisabled) return;
                        e.preventDefault();
                    }}
                    style={{
                        border: '2px dashed #ccc',
                        borderRadius: '5px',
                        padding: '10px',
                        backgroundColor: isDisabled ? '#f9f9f9' : '#fafafa',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                    }}
                >

                    {/* Label */}
                    <Grid item lg={12} sm={12}>
                        <Typography variant="body2" sx={{ fontSize: '12px' }}>
                            {label} {isRequired && <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>}
                        </Typography>
                    </Grid>

                    {/* File Picker */}
                    <Grid item lg={2.5} sm={6}>
                        <Button
                            variant="contained"
                            component="label"
                            size="small"
                            sx={{
                                minWidth: '20px',
                                height: '20px',
                                fontSize: '8px',
                                padding: '0.5',
                                color: 'black',
                                border: isDisabled ? '1px solid lightgray' : '1px solid black',
                                backgroundColor: 'lightgray',
                            }}
                            disabled={isDisabled}
                        >
                            Choose File
                            <input
                                type="file"
                                multiple={isMultiFile}
                                hidden
                                ref={this.fileInputRefs[fieldName]}
                                onChange={(e) => {
                                    this.setState({ activeUploadFieldName: fieldName });
                                    this.handleFileUpload(e, fieldName);
                                }}
                            />
                        </Button>
                    </Grid>

                    {/* Uploaded Files */}
                    <Grid item lg={7.5} sm={6} sx={{ display: 'flex', flexWrap: 'wrap', gap: '5px', mt: -1 }}>
                        {files.map((file: UploadedFile, index: number) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    flexWrap: 'wrap'
                                }}
                            >
                                <span style={{ fontSize: '10px' }}>{file.name}</span>
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        this.handleFileRemove(fieldName, index);
                                        if (files.length === 1) {
                                            this.setState({ activeUploadFieldName: '' });
                                        }
                                    }}
                                    disabled={isDisabled}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </div>
                        ))}
                    </Grid>

                    {/* Upload / ReUpload Button */}
                    <Grid item lg={2} sx={{ mt: -1 }}>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                minWidth: '40px',
                                height: '24px',
                                fontSize: '10px',
                                padding: '5px',
                                color: 'white',
                                backgroundColor: '#1976d2',
                                '&:hover': { backgroundColor: '#115293' },
                            }}
                            disabled={files.length === 0}
                            onClick={() => this.handleOpenConfirmDialog(fieldName, FileId)}
                        >
                            {fileExists ? 'ReUpload' : 'Upload'}
                        </Button>

                    </Grid>

                    {/* Success Message */}
                    {isDisabled && lockedFieldsMessage && (
                        <Grid item lg={12}>
                            <div style={{
                                color: 'green',
                                fontSize: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                            }}>
                                <CheckCircleOutlineRoundedIcon sx={{ fontSize: '1rem' }} />
                                <span>{lockedFieldsMessage}</span>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </fieldset>
        );
    };


    renderExtraFileUploads(fieldName: string, FileId: any) {
        if (!this.fileInputRefs[fieldName]) {
            this.fileInputRefs[fieldName] = createRef();
        }
        const isMultiFile = ["Schedule"].includes(fieldName);
        const { uploadedFiles, activeTab, errors, successfullyUploadedFields, lockedFieldsMessage } = this.state;
        const { fileReUploadInfo } = this.props;
        const fileExists = fileReUploadInfo.some((file: { FileForId: any; }) => file.FileForId === FileId);
        const files = (uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];
        const isUploaded = successfullyUploadedFields?.[activeTab]?.[fieldName] === true;
        const isActiveField = this.state.activeUploadFieldName === fieldName;
        const isDisabled = isUploaded || (this.state.activeUploadFieldName && !isActiveField);
        const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();
        const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
            e.preventDefault();
            if (isDisabled) return;
            const droppedFiles = e.dataTransfer.files;
            if (!isMultiFile && droppedFiles.length > 1) {
                alert(`Only one file is allowed for the "${fieldName}" field.`);
                return;
            }
            const fileList = isMultiFile ? Array.from(droppedFiles) : [droppedFiles[0]];
            const event = {
                target: {
                    files: fileList
                }
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            this.handleFileUpload(event, fieldName);
        };
        return (
            <>
                <div
                    onDrop={(e) => this.handleDrop(e, fieldName)}
                    onDragOver={(e) => e.preventDefault()}
                    onDragLeave={(e) => e.preventDefault()}
                    style={{
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        padding: '20px',
                        marginBottom: '10px',
                        backgroundColor: isDisabled ? '#f9f9f9' : '#fafafa',
                        cursor: isDisabled ? 'not-allowed' : 'default',
                    }}
                >
                    <Grid container key={fieldName} spacing={1} alignItems="flex-start">
                        <Grid item lg={2.5} sm={6}>
                            <Typography variant="body2" sx={{ fontSize: '12px' }}>{fieldName}</Typography>
                        </Grid>

                        <Grid item lg={2.5}>
                            <Button
                                variant="contained"
                                component="label"
                                size="small"
                                disabled={isDisabled}
                                sx={{
                                    minWidth: '20px',
                                    height: '20px',
                                    fontSize: '8px',
                                    padding: '0.5',
                                    color: 'black',
                                    border: isDisabled ? '1px solid lightgray' : '1px solid black',
                                    backgroundColor: 'lightgray',
                                }}
                            >
                                Choose File
                                <input
                                    type="file"
                                    multiple={isMultiFile}
                                    hidden
                                    ref={this.fileInputRefs[fieldName]}
                                    onChange={(e) => {
                                        this.setState({ activeUploadFieldName: fieldName });
                                        this.handleFileUpload(e, fieldName);
                                    }}
                                />
                            </Button>
                        </Grid>

                        <Grid item lg={5} sm={6} sx={{ display: "flex", flexWrap: "wrap", gap: "5px", overflow: "auto" }}>
                            {Array.isArray(files) && files.length > 0 && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: "5px", maxWidth: "100%" }}>
                                    {files.map((fileObj, index) => (
                                        <div key={index}
                                            style={{
                                                display: 'flex',
                                                gap: "5px",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                maxWidth: "100%",
                                                wordBreak: "break-word",
                                            }}>
                                            <span style={{
                                                fontSize: "10px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                {fileObj?.file?.name}
                                            </span>
                                            <IconButton size="small"
                                                onClick={() => {
                                                    this.handleFileRemove(fieldName, index);
                                                    if (files.length === 1) {
                                                        this.setState({ activeUploadFieldName: '' });
                                                    }
                                                }}
                                                disabled={isDisabled}>
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Grid>
                        <Grid item lg={2}>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    minWidth: '40px',
                                    height: '24px',
                                    fontSize: '10px',
                                    padding: '5px',
                                    color: 'white',
                                    backgroundColor: '#1976d2',
                                    '&:hover': { backgroundColor: '#115293' },
                                }}
                                disabled={files.length === 0}
                                onClick={() => this.handleOpenConfirmDialog(fieldName, FileId)}
                            >
                                {fileExists ? 'ReUpload' : 'Upload'}
                            </Button>
                        </Grid>

                        {isDisabled && lockedFieldsMessage && (
                            <Grid item lg={12}>
                                <div style={{
                                    color: 'green',
                                    fontSize: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                }}>
                                    <CheckCircleOutlineRoundedIcon sx={{ fontSize: '1rem' }} />
                                    <span>{lockedFieldsMessage}</span>
                                </div>
                            </Grid>
                        )}

                        {errors[activeTab]?.sourceDoc && (
                            <span style={{ color: "red", fontSize: 'smaller' }}>{errors[activeTab]?.sourceDoc}</span>
                        )}
                    </Grid>
                </div>
            </>
        );
    }

    render() {
        const { activeTab, errors, snackbarOpen, snackbarMessage, loading, snackbarSeverity } = this.state;
        const { modelJobTypeId } = this.props;
        const isReupload = this.props.fileReUploadInfo.some(
            (file: { FileForId: any }) => file.FileForId === this.state.dialogFileId
        );
        const actionLabel = isReupload ? 'ReUpload' : 'Upload';

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: -60,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <div>
                    <div style={{ maxHeight: '330px', overflowY: 'auto' }}>
                        {modelJobTypeId === 1 && (<text>Automatic Renewal</text>)}
                        {modelJobTypeId === 2 && (<text>Marketed Renewal</text>)}
                        <Grid container spacing={1} sx={{ display: { xs: 'flex', lg: 'flex' } }}>
                            <Grid item lg={6} xs={12} >
                                <Grid item lg={12} sm={6}>
                                    {this.renderFileUpload("Current Term Policy", "Current Term Policy", true, 1)}
                                    {errors[activeTab]?.currentTermPolicy && (
                                        <span style={{ color: 'red', fontSize: 'smaller' }}>
                                            {errors[activeTab]?.currentTermPolicy}
                                        </span>
                                    )}
                                </Grid>

                                <Grid item lg={12} sm={6} mt={0.5}>
                                    {this.renderFileUpload("Current Endorsement", "Endorsement", false, 3)}
                                </Grid>
                                {modelJobTypeId === 2 && (
                                    <Grid item lg={12} sm={6}>
                                        <>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                                Select Source Document <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>
                                            </Typography>

                                            <fieldset style={{
                                                display: "flex",
                                                border: "1px solid #ddd", padding: "10px", borderRadius: "5px", minHeight: "70px",
                                                flexDirection: "column",
                                                gap: "10px",
                                            }}>
                                                {[
                                                    { label: 'Proposal', id: 7 },
                                                    { label: 'Acord Application', id: 5 },
                                                    { label: 'Carrier Quote', id: 6 },
                                                    { label: 'Binder', id: 9 },
                                                    { label: 'Schedule', id: 8 },
                                                ].map((item) => this.renderExtraFileUploads(item.label, item.id))}
                                            </fieldset>
                                        </>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item lg={6} xs={12} >
                                <Grid item lg={12} sm={6}>
                                    {this.renderFileUpload("Prior Term Policy", "Prior Term Policy", modelJobTypeId === 2 ? false : true, 2)}
                                    {errors[activeTab]?.priorTermPolicy && (
                                        <span style={{ color: 'red', fontSize: 'smaller' }}>
                                            {errors[activeTab]?.priorTermPolicy}
                                        </span>
                                    )}
                                </Grid>
                                <Grid item lg={12} sm={6} marginTop={0.5}>
                                    {this.renderFileUpload("Prior Endorsement", "Endorsement", false, 4)}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Dialog open={this.state.openConfirmDialog} onClose={this.handleCloseConfirmDialog}>
                            <DialogContent sx={{
                                padding: '0px 30px',
                                paddingTop: '15px',
                                paddingBottom: '20px',
                                textAlign: 'center',
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#E5E7EB',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <FileUpload sx={{ color: '#111827', fontSize: 30 }} />
                                    </Box>
                                </Box>
                                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                    {actionLabel} Doc!
                                </DialogTitle>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure you want to {actionLabel} this <br />
                                </DialogContentText>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            px: 4,
                                            borderRadius: '6px',
                                        }}
                                        onClick={this.handleConfirmUpload}
                                    >
                                        Yes
                                    </Button>
                                    <Button
                                        // variant="outlined"
                                        onClick={this.handleCloseConfirmDialog}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            border: '0.5px solid #53494987',
                                            px: 4,
                                            borderRadius: '6px',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}
                                    >
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </div>
                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={2500}
                        onClose={this.handleCloseSnackbar}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
                            {snackbarMessage}
                        </Alert>
                    </Snackbar>

                </div>
            </>
        );
    }

}

export default FileReUploadpage;
